import { useEffect, useState } from "react";
import { useStorage, useFirestore } from "reactfire";
import { getDownloadURL, ref, getBlob } from "firebase/storage";
import toast, { Toaster } from "react-hot-toast";
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  doc,
  orderBy,
  limit,
  collectionGroup,
  onSnapshot,
} from "firebase/firestore";
import { Spinner } from "react-bootstrap";

const FirebaseStoragePhotosComponent = ({ vehicleId }) => {
  const [imageBlobs, setImageBlobs] = useState([]);
  const [photosArray, setPhotosArray] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const storage = useStorage(); // Assuming you have a hook to get Firebase Storage instance
  const firestore = useFirestore();
  //   const { downloadURL } = useStorageDownloadURL(storage, file.fullPath);

  const getBlobImg = async (file) => {
    if (!file || !file.fullPath) {
      console.error("File or fullPath is not defined");
      return;
    }
    const storageRef = ref(storage, file.fullPath);
    const tmpBlob = await getDownloadURL(storageRef);
    if (!tmpBlob) {
      console.error("Failed to get blob from storage");
      return;
    } else {
      return tmpBlob;
    }
  };

  // Get the recon-form-inspection collection with the vehicleId /reconditioning-process/{vehicleId}/recon-form-inspection/ from firestore
  const getPhotosFromCollection = async (collectionName) => {
    if (!vehicleId) {
      console.error("Vehicle ID is required to fetch photos");
      return;
    }
    setIsLoading(true);
    const inspectionFormsRef = collection(
      firestore,
      `reconditioning-process/${vehicleId}/${collectionName}`
    );
    const q = query(inspectionFormsRef, orderBy("createdAt", "desc"));
    const querySnapshot = await getDocs(q);
    const photos = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      console.log("photo data:", data);
      if (data.photos && data.photos.length > 0) {
        data.photos.forEach((photo) => {
          photos.push(photo);
        });
      }
    });

    // getBlobImg for each photo and update the object with the blob
    for (var i = 0; i < photos.length; i++) {
      const tmpPhoto = photos[i];
      console.log("tmpPhoto:", tmpPhoto);
      const url = await getBlobImg(tmpPhoto);
      if (url) {
        photos[i].url = url;
      } else {
        console.error("Failed to get blob for photo:", photos[i]);
      }
    }

    setPhotosArray((prev) => [...prev, ...photos]);
    setIsLoading(false);
    return photos;
  };

  useEffect(() => {
    if (vehicleId) {
      // Fetch photos from the recon-form-inspection collection
      getPhotosFromCollection("recon-form-inspection");
      // Fetch photos from the recon-form-photo collection
    }
  }, [vehicleId]);

  // Clean up function to reset state when component unmounts
  useEffect(() => {
    return () => {
      setPhotosArray([]);
      setImageBlobs([]);
      setIsLoading(true);
    };
  }, []);

  return (
    <div>
      {/* <img src={file.url} alt={file.name} /> */}
      {/* <pre>{JSON.stringify(photosArray, null, 2)}</pre> */}
      {isLoading && <Spinner animation="border" size="sm" />}
      {photosArray.length && (
        <div>
          <h4>Recon photos</h4>
          {photosArray.map((file, index) => (
            <div key={index} style={{ marginBottom: "10px" }}>
              <img
                src={file.url}
                alt={file.name}
                style={{ maxWidth: "100%", height: "auto" }}
              />
              {/* <p>{file.name}</p> */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FirebaseStoragePhotosComponent;
